import React from 'react';

const Vue_VShow = () => {
  return (
    <div>
      <h1>Vue_VShow Component</h1>
      <p>This is the Vue_VShow tutorial page.</p>
    </div>
  );
}

export default Vue_VShow;
